import { render, staticRenderFns } from "./AvatarCustomContent.vue?vue&type=template&id=96f3c654&"
import script from "./AvatarCustomContent.vue?vue&type=script&lang=js&"
export * from "./AvatarCustomContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports